(() => {
  const mobile = matchMedia('(max-width: 989px)');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const controllers = new Map();
  const followTime = 35;
  const nativeTimeline = CSS.supports('animation-timeline', 'scroll(root block)') &&
    CSS.supports('animation-range', '0px 140px');

  const initialize = container => {
    const headers = container.querySelectorAll('.header-wrapper .header--mobile-center');
    for (const header of headers) {
      if (controllers.has(header)) continue;
      const heading = header.querySelector('.header__heading');
      const link = header.querySelector('.header__heading-link--mark');
      if (!heading || !link) continue;
      const abort = new AbortController();
      let frame = 0;
      let previousTime = 0;
      let progress = 0;
      let target = 0;
      let compactScale = 1;
      let offset = 0;
      let distance = 140;
      let viewportWidth = window.innerWidth;
      const readProgress = () => Math.max(0, Math.min(1, window.scrollY / distance));
      const write = () => {
        const eased = progress * progress * (3 - 2 * progress);
        const scale = 1 + (compactScale - 1) * eased;
        link.style.transform = `translate3d(-50%, calc(-50% + ${offset * (1 - eased)}px), 0) scale(${scale})`;
        header.dataset.mobileLogoProgress = progress.toFixed(4);
      };
      const draw = time => {
        frame = 0;
        const elapsed = previousTime ? Math.max(0, time - previousTime) : 1000 / 60;
        previousTime = time;
        target = readProgress();
        progress += (target - progress) * (1 - Math.exp(-elapsed / followTime));
        if (Math.abs(target - progress) < 0.0005) progress = target;
        write();
        if (progress !== target) frame = requestAnimationFrame(draw);
        else previousTime = 0;
      };
      const queue = () => {
        if (header.dataset.mobileLogoDriver !== 'fallback') return;
        target = readProgress();
        if (target !== progress && !frame) frame = requestAnimationFrame(draw);
      };
      const measure = () => {
        cancelAnimationFrame(frame);
        frame = 0;
        previousTime = 0;
        link.style.removeProperty('transform');
        link.style.removeProperty('--mobile-logo-compact-scale');
        delete header.dataset.mobileLogoDriver;
        if (!mobile.matches || reduced.matches || !header.closest('.header-wrapper--home-intro')) {
          delete header.dataset.mobileLogoProgress;
          return;
        }
        const style = getComputedStyle(link);
        compactScale = parseFloat(getComputedStyle(heading).width) / parseFloat(style.width);
        offset = new DOMMatrixReadOnly(style.transform).m42 + parseFloat(style.height) / 2;
        distance = parseFloat(getComputedStyle(header).getPropertyValue('--mobile-logo-collapse-distance')) || 140;
        link.style.setProperty('--mobile-logo-compact-scale', String(compactScale));
        if (nativeTimeline) {
          header.dataset.mobileLogoDriver = 'native';
          delete header.dataset.mobileLogoProgress;
          return;
        }
        header.dataset.mobileLogoDriver = 'fallback';
        target = progress = readProgress();
        write();
      };
      window.addEventListener('scroll', queue, { passive: true, signal: abort.signal });
      window.addEventListener('resize', () => {
        if (window.innerWidth === viewportWidth) return;
        viewportWidth = window.innerWidth;
        measure();
      }, { passive: true, signal: abort.signal });
      window.addEventListener('pageshow', measure, { signal: abort.signal });
      document.addEventListener('afterlight:page', measure, { signal: abort.signal });
      document.addEventListener('visibilitychange', () => { if (!document.hidden) measure(); }, { signal: abort.signal });
      mobile.addEventListener('change', measure, { signal: abort.signal });
      reduced.addEventListener('change', measure, { signal: abort.signal });
      measure();
      controllers.set(header, () => {
        abort.abort();
        cancelAnimationFrame(frame);
        link.style.removeProperty('transform');
        link.style.removeProperty('--mobile-logo-compact-scale');
        delete header.dataset.mobileLogoDriver;
        delete header.dataset.mobileLogoProgress;
      });
    }
  };

  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [header, dispose] of controllers) {
      if (event.target.contains(header)) { dispose(); controllers.delete(header); }
    }
  });
})();
